export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"description","content":"Choisissez la formule Omra qui vous convient et personnalisez chaque étape de votre pèlerinage."},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"default"},{"name":"apple-mobile-web-app-title","content":"Tayba Travel"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"theme-color","content":"#d0a444"}],"link":[{"rel":"manifest","href":"/manifest.webmanifest"},{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"apple-touch-icon","href":"/pwa-192x192.png"},{"rel":"apple-touch-icon","sizes":"512x512","href":"/pwa-512x512.png"}],"style":[],"script":[{"innerHTML":"\n(function(){\n  if(location.hostname!=='localhost'&&!location.hostname.startsWith('192.168'))return;\n  if(!('serviceWorker' in navigator))return;\n  if(sessionStorage.getItem('sw_dev_cleaned')==='1')return;\n  navigator.serviceWorker.getRegistrations().then(function(regs){\n    if(!regs.length)return;\n    sessionStorage.setItem('sw_dev_cleaned','1');\n    Promise.all(\n      regs.map(function(r){return r.unregister();}).concat(\n        [caches.keys().then(function(keys){return Promise.all(keys.map(function(k){return caches.delete(k);}));})]\n      )\n    ).then(function(){location.reload();});\n  });\n})();","type":"text/javascript"}],"noscript":[],"htmlAttrs":{"lang":"fr"},"title":"Tayba Travel | Votre partenaire pour Omra & Hajj en Europe","titleTemplate":"%s - Tayba Travel | Votre partenaire pour Omra & Hajj en Europe"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false